<template>
  <van-tabbar route class="tabbar" active-color="var(--primary-color)" inactive-color="#666666">
    <van-tabbar-item to="/clerk/clerk-houtai" v-if="$ClerkAccess.includes('clerk-houtai')">
      <van-icon slot="icon" slot-scope="props" :color="props.active? 'var(--primary)' : '#999'" name="cashier-o" size="25px"/>
      <span>首页</span>
    </van-tabbar-item>
    <van-tabbar-item to="/clerk/order/list" v-if="$ClerkAccess.includes('order')">
      <van-icon slot="icon" slot-scope="props" :color="props.active? 'var(--primary)' : '#999'" name="orders-o" size="25px"/>
      <span>订单</span>
    </van-tabbar-item>
    <van-tabbar-item to="/clerk/clerk-user" v-if="$ClerkAccess.includes('clerk-houtai')">
      <van-icon slot="icon" slot-scope="props" :color="props.active? 'var(--primary)' : '#999'" name="user-o" size="25px"/>
      <span>店员中心</span>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { Tabbar, TabbarItem, Icon } from 'vant';
import Vue from "vue"

Vue.use(Tabbar)
    .use(TabbarItem)
    .use(Icon)

export default {
  name: "tabbar",
  data(){
    return {
    }
  }
}
</script>

<style scoped>

  .tabbar{
    display: flex;
  }

</style>
